import { DateRangePicker } from '@/kit/DatePickers/DateRangePicker';
import { PeriodSelect } from '@/components/TaxReport/PeriodSelect';
import { OperationTypeSelect } from '@/components/TaxReport/OperationTypeSelect';
import { ExportButton } from '@/components/TaxReport/ExportButton';
import { ReportFaqButton } from '@/components/TaxReport/ReportFaqButton';
import { Chips } from '@/components/TaxReport/Chips';
import s from './index.module.scss';

export const FilterViewDesktop = ({ params, setParams, onFilterChange }) => {
  return (
    <div>
      <div className={s.header}>
        <div className={s.filters}>
          <PeriodSelect
            range={params.range}
            onChange={range => onFilterChange('range', range)}
          />
          <DateRangePicker
            range={params.range}
            setRange={range => onFilterChange('range', range)}
            maxDate={new Date()}
          />
          <OperationTypeSelect
            selected={params.operation_types}
            onChange={types => onFilterChange('operation_types', types)}
          />
        </div>
        <div className={s.right}>
          <ExportButton />
          <ReportFaqButton />
        </div>
      </div>
      <Chips params={params} setParams={setParams} />
    </div>
  );
};
